<section class="outline-none" tabIndex="0">
  <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>

  <div *ngIf="totalItems > 0 && !isLoading" class="vtmn-title-4 mt-4">
    {{ totalItems | totalResults }}
  </div>

  <app-attendee-pagination
    class="block mt-4"
    *ngIf="!isLoading"
    [items]="items"
    [topBanner]="sportGroupBanner"
    [itemsType]="paginationType.ACTIVITIES"
    [hasLoadMoreButton]="hasLoadMoreButton"
    (filterReset)="resetFilters()"
  ></app-attendee-pagination>

  <app-list-pagination
    *ngIf="!isLoading && pagination"
    [pagination]="pagination"
    targetUrl="/attendee.result-page/attendee.activities"
  />
</section>
